/* eslint-disable camelcase */
/** Providers from the tenant CDP setting WHATSAPP_CHATBOT_AGENT_CONFIG: {"providers":[{"id","title",...}]}. */
export function agentProviderOptions(configStr) {
  let parsed = configStr
  if (typeof configStr === 'string') {
    try {
      parsed = configStr ? JSON.parse(configStr) : {}
    } catch (e) {
      parsed = {}
    }
  }
  const list = (parsed && Array.isArray(parsed.providers)) ? parsed.providers : []
  const seen = {}
  const options = []
  for (let i = 0; i < list.length; i++) {
    const p = list[i]
    const id = String((p && p.id) || '').trim()
    if (!id || seen[id]) continue
    seen[id] = true
    options.push({ key: id, label: String((p && p.title) || id).trim() || id })
  }
  return options
}

export function labelForAgentProviderId(options, providerId) {
  const id = String(providerId || '').trim()
  if (!id) return ''
  const list = options || []
  for (let i = 0; i < list.length; i++) {
    if (list[i] && list[i].key === id) return list[i].label || id
  }
  return id
}

function ensureProviderOptions(options, currentId) {
  const list = Array.isArray(options) ? options.slice() : []
  const id = String(currentId || '').trim()
  if (!id || list.some(o => o && o.key === id)) return list
  return [{ key: id, label: id + ' (not configured)' }].concat(list)
}

export function getChatbotAgentFieldDef(options, nodeData) {
  const currentId = String((nodeData && nodeData.providerId) || '')
  return {
    title: 'Trigger Agent',
    formType: 'edit',
    ctaButtonText: 'Save',
    steps: [{
      fields: [
        {
          key: 'providerId',
          type: 'select',
          label: 'AI Agent',
          tip: 'Agents are configured for this account by Slixta',
          options: ensureProviderOptions(options, currentId),
          v_required: { value: true, err: 'Select an AI agent' },
          placement: 'left',
        },
        {
          key: 'openingMessage',
          type: 'edit_text',
          label: 'Opening message (optional)',
          tip: 'Sent to the agent when the contact reaches this step. If empty, the agent waits for the contact\'s next message.',
          multiline: true,
          rows: '3',
          v_required: { value: false, err: '' },
          placement: 'left',
        },
      ],
    }],
  }
}

export function agentNodeDataToFormItem(data) {
  return {
    providerId: String((data && data.providerId) || ''),
    openingMessage: String((data && data.openingMessage) || ''),
  }
}

export function formDataToAgentNodeData(formData) {
  return {
    providerId: String((formData && formData.providerId) || '').trim(),
    openingMessage: String((formData && formData.openingMessage) || '').trim(),
  }
}
